import { ReactNode } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

export default function Container({ children, className = '' }: ContainerProps) {
  const { theme } = useTheme();
  
  return (
    <div className={`mx-auto px-4 sm:px-6 lg:px-8 w-full ${
      theme === 'dark' ? 'text-gray-100' : ''
    } ${className}`}>
      {children}
    </div>
  );
}
